.panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.hint {
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink-3);
}

.button {
  min-height: 52px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  color: var(--ink);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

/* The accent keeps its colour in both themes, so the text on it stays dark
 * rather than following --ink. */
.primary {
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
}

.primary:active {
  box-shadow: none;
  transform: translate(3px, 3px);
}

.button:disabled {
  background: var(--sunk);
  color: var(--ink-3);
  box-shadow: none;
  cursor: default;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
